import { memo, useCallback } from 'react';
import { Key } from 'react-aria-components';

import { Button, Flex, Label, ListBox, ListBoxItem, Popover, Select, SelectValue, Text } from '@/components/core';
import { ChevronIcon } from '@/components/icons';
import { useTriggerStore } from '@/store';
import { toString } from '@/utils';

export type HttpMethodProps = {
  defaultHttpMethod?: 'post' | 'get' | 'put' | 'patch' | 'delete';
};

const IHttpMethod = ({ defaultHttpMethod = 'post' }: HttpMethodProps) => {
  const action = useTriggerStore((state) => state.action);
  const updateAction = useTriggerStore((state) => state.updateAction);

  const updateHttpMethod = useCallback(
    (httpMethod: Key | null) => {
      updateAction({ config: { ...action.config, httpMethod: httpMethod?.toString() ?? defaultHttpMethod } });
    },
    [action.config, defaultHttpMethod, updateAction]
  );

  return (
    <Flex col className="gap-xs">
      <Label>HTTP Method</Label>
      <Select
        value={toString(action?.config?.httpMethod)?.toLowerCase() ?? defaultHttpMethod}
        onChange={updateHttpMethod}
      >
        <div className="flex grow-0">
          <Button variant="secondary">
            <Text slot="description" className="grow">
              <SelectValue />
            </Text>
            <ChevronIcon rotation="down" />
          </Button>
        </div>
        <Popover>
          <ListBox>
            <ListBoxItem id="post">
              <Text>POST</Text>
            </ListBoxItem>
            <ListBoxItem id="get">
              <Text>GET</Text>
            </ListBoxItem>
            <ListBoxItem id="put">
              <Text>PUT</Text>
            </ListBoxItem>
            <ListBoxItem id="patch">
              <Text>PATCH</Text>
            </ListBoxItem>
            <ListBoxItem id="delete">
              <Text>DELETE</Text>
            </ListBoxItem>
          </ListBox>
        </Popover>
      </Select>
    </Flex>
  );
};

export const HttpMethod = memo(IHttpMethod) as typeof IHttpMethod;
